/* Buddha Gear theme: small, dependency-free behaviour.
   Everything works without JavaScript (plain links and forms); this file only makes it nicer. */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.BG && window.BG.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  /* ---------- Phone menu drawer ---------- */
  function initDrawer() {
    var drawer = document.getElementById('site-drawer');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-drawer-open]');
    var closers = drawer.querySelectorAll('[data-drawer-close]');
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    var enabled = document.body.getAttribute('data-reveal') !== 'false';
    var inThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
    if (inThemeEditor) {
      function showEditorContent(root) {
        if (root.matches && root.matches('.reveal')) root.classList.add('is-in');
        if (root.querySelectorAll) root.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
      }
      showEditorContent(document);
      document.addEventListener('shopify:section:load', function (event) { showEditorContent(event.target); });
      document.addEventListener('shopify:block:select', function (event) { showEditorContent(event.target); });
      return;
    }
    if (!enabled || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    items.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
    // Safety net: never leave content hidden if the observer does not fire.
    setTimeout(function () { items.forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
  }

  /* ---------- Cart count + toast ---------- */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }
  function toast(text) {
    var t = document.getElementById('bg-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'bg-toast';
      t.setAttribute('role', 'status');
      t.style.cssText = 'position:fixed;left:50%;bottom:28px;transform:translateX(-50%);z-index:70;background:var(--ink);color:#f4ecdc;padding:14px 22px;border-radius:999px;font-size:14px;font-weight:600;box-shadow:0 20px 40px rgba(23,1,3,.25);transition:opacity .3s ease';
      document.body.appendChild(t);
    }
    t.textContent = text;
    t.style.opacity = '1';
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.style.opacity = '0'; }, 2600);
  }

  /* ---------- Quick add (cards) ---------- */
  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-quick-add]');
      if (!form || !window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            setCartCount(cart.item_count);
            toast((res.j.product_title || 'Item') + ' added to your cart');
          });
        })
        .catch(function (err) { toast(err.message); })
        .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- Product page: gallery, variants, quantity ---------- */
  function initProduct() {
    document.querySelectorAll('[data-product]').forEach(function (root) {
      var main = root.querySelector('[data-main-image]');
      root.querySelectorAll('[data-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!main) return;
          main.src = btn.getAttribute('data-src');
          main.srcset = btn.getAttribute('data-srcset') || '';
          main.alt = btn.getAttribute('data-alt') || '';
          root.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
        });
      });

      var json = root.querySelector('[data-variants]');
      var form = root.querySelector('form[data-product-form]');
      if (json && form) {
        var variants = JSON.parse(json.textContent);
        var idInput = form.querySelector('[name="id"]');
        var priceEl = root.querySelector('[data-price]');
        var addBtn = form.querySelector('[data-add-button]');
        var addLabel = addBtn ? addBtn.textContent : '';
        var sync = function () {
          var picked = [];
          root.querySelectorAll('[data-option]').forEach(function (fs) {
            var checked = fs.querySelector('input:checked');
            picked.push(checked ? checked.value : null);
          });
          var match = variants.filter(function (v) {
            return v.options.every(function (o, i) { return o === picked[i]; });
          })[0];
          if (!match) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; } return; }
          idInput.value = match.id;
          if (priceEl) {
            priceEl.innerHTML = money(match.price) + (match.compare_at_price > match.price ? ' <s>' + money(match.compare_at_price) + '</s>' : '');
          }
          if (addBtn) { addBtn.disabled = !match.available; addBtn.textContent = match.available ? addLabel : 'Sold out'; }
          if (match.featured_image && main) { main.src = match.featured_image.src || match.featured_image; main.srcset = ''; }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState(null, '', url);
        };
        root.querySelectorAll('[data-option] input').forEach(function (i) { i.addEventListener('change', sync); });
      }
    });

    document.querySelectorAll('[data-qty]').forEach(function (q) {
      var input = q.querySelector('input');
      q.querySelectorAll('button[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var min = parseInt(input.min || '0', 10);
          var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-step'), 10));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Cart page: Kickflip design details, auto-update ---------- */
  function initCart() {
    // Kickflip stores the readable patch summary inside a hidden JSON property; show it.
    document.querySelectorAll('[data-kickflip-attrs]').forEach(function (el) {
      try {
        var list = JSON.parse(el.getAttribute('data-kickflip-attrs'));
        var out = list.filter(function (a) { return a.key && a.key.charAt(0) !== '_' && a.value; });
        if (!out.length) return;
        el.innerHTML = '';
        out.forEach(function (a) {
          var li = document.createElement('li');
          var k = document.createElement('strong');
          k.textContent = a.key + ': ';
          li.appendChild(k);
          li.appendChild(document.createTextNode(Array.isArray(a.value) ? a.value.join(', ') : String(a.value)));
          el.appendChild(li);
        });
        el.hidden = false;
      } catch (e) { /* leave the fallback text */ }
    });
    var form = document.getElementById('cart-form');
    if (!form) return;
    var timer;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, 500);
    });
  }

  /* ---------- Hero photo cross-fade ---------- */
  function initHero() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-hero-track]').forEach(function (track) {
      var frames = track.querySelectorAll('.hero__frame');
      if (frames.length < 2) return;
      var i = 0;
      var ms = (parseInt(track.getAttribute('data-interval'), 10) || 6) * 1000;
      setInterval(function () {
        if (document.hidden) return;
        var next = (i + 1) % frames.length;
        var img = frames[next].querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
        frames[i].classList.remove('is-active');
        frames[next].classList.add('is-active');
        i = next;
      }, ms);
      // Warm up the next photo early so the first change is smooth.
      setTimeout(function () { var im = frames[1].querySelector('img'); if (im) im.loading = 'eager'; }, 1500);
    });
  }

  /* ---------- Simple choosers (e.g. pick a crystal) ---------- */
  function initChoosers() {
    document.querySelectorAll('[data-chooser]').forEach(function (root) {
      var out = root.querySelector('[data-chooser-line]');
      root.querySelectorAll('button[data-line]').forEach(function (b) {
        b.addEventListener('click', function () {
          root.querySelectorAll('button[data-line]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          if (out) out.textContent = b.getAttribute('data-line');
        });
      });
    });
  }

  /* ---------- Header height (for sticky bars) ---------- */
  function initHeaderHeight() {
    var h = document.querySelector('.site-header');
    if (!h) return;
    var set = function () { document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px'); };
    set();
    window.addEventListener('resize', set);
  }

  /* ---------- Shop chip bar: highlight the row in view ---------- */
  function initChipSpy() {
    var bar = document.querySelector('.chip-bar__inner');
    if (!bar || !('IntersectionObserver' in window)) return;
    var chips = {};
    bar.querySelectorAll('a[href^="#row-"]').forEach(function (a) { chips[a.getAttribute('href').slice(1)] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var chip = chips[e.target.id];
        if (!chip || !e.isIntersecting) return;
        Object.keys(chips).forEach(function (k) { chips[k].classList.toggle('is-active', chips[k] === chip); });
        bar.scrollTo({ left: chip.offsetLeft - 20, behavior: 'smooth' });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    Object.keys(chips).forEach(function (id) { var row = document.getElementById(id); if (row) io.observe(row); });
  }

    /* Two-row product-family shelves with desktop arrows and touch scrolling. */
  function initCatalogCarousels() {
    document.querySelectorAll('[data-catalog-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('.catalog-track');
      var previous = carousel.querySelector('[data-catalog-scroll="prev"]');
      var next = carousel.querySelector('[data-catalog-scroll="next"]');
      if (!track || !previous || !next) return;

      function update() {
        var canScroll = track.scrollWidth > track.clientWidth + 2;
        carousel.classList.toggle('is-scrollable', canScroll);
        previous.disabled = !canScroll || track.scrollLeft <= 2;
        next.disabled = !canScroll || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      previous.addEventListener('click', function () {
        track.scrollBy({ left: -Math.max(track.clientWidth * 0.8, 180), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: Math.max(track.clientWidth * 0.8, 180), behavior: 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeaderHeight();
    initCatalogCarousels();
    initChipSpy();
    initHero();
    initChoosers();
    initDrawer();
    initReveal();
    initQuickAdd();
    initProduct();
    initCart();
  });
})();
